import { PublicClientApplication, Configuration } from '@azure/msal-browser';
import { azureAdConfig } from '../config/azureAd';

const msalConfig: Configuration = {
  auth: {
    clientId: azureAdConfig.clientId,
    authority: azureAdConfig.authority,
    redirectUri: azureAdConfig.redirectUri,
    postLogoutRedirectUri: azureAdConfig.postLogoutRedirectUri,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);
